module.exports = __webpack_public_path__ + "img/search.b2fccec5.svg";